import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	loading_details: false,
	loading_building_floors: false,
	loading_nav_nodes: false,
	loading_assets: false,
	location_details: null,
	location_id: null,
	location_building_floors: null,
	building_floor: null,
	loading_building_floor: false,
	nav_nodes: null,
	loading_point_of_interests: false,
	point_of_interests: null,
	location_assets: null
};

export default function locationDetailPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_LOCATION_BUILDING_FLOORS_REQUEST:
		case ActionTypes.GET_LOCATION_BUILDING_FLOORS_ERROR:
		case ActionTypes.GET_LOCATION_BUILDING_FLOORS_SUCCESS:
		case ActionTypes.GET_LOCATION_GEOJSON_REQUEST:
		case ActionTypes.GET_LOCATION_GEOJSON_ERROR:
		case ActionTypes.GET_LOCATION_GEOJSON_SUCCESS:
		case ActionTypes.GET_LOCATION_DETAIL_REQUEST:
		case ActionTypes.GET_LOCATION_DETAIL_ERROR:
		case ActionTypes.GET_LOCATION_DETAIL_SUCCESS:
		case ActionTypes.GET_LOCATION_ASSETS_REQUEST:
		case ActionTypes.GET_LOCATION_ASSETS_ERROR:
		case ActionTypes.GET_LOCATION_ASSETS_SUCCESS:
		case ActionTypes.GET_LOCATION_ID_BY_REMOTE_ID_REQUEST:
		case ActionTypes.GET_LOCATION_ID_BY_REMOTE_ID_ERROR:
		case ActionTypes.GET_LOCATION_ID_BY_REMOTE_ID_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_LOCATION_DETAIL_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_LOCATION_DETAIL_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
